import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../common/SnackbarAlert';
import React from 'react';

function CreatEdit({ setNewValue = null, closeCreateEditForm, LocationEditDatas, editStatus, type, customerId }) {

  const regex = /[A-Za-z]/;

  const LocationSchema = Yup.object().shape({
    name: Yup.string()
      .transform((value) => value.trim())
      .required('Location Name is required')
      .min(3, 'Location Name must be at least 3 characters')
      .matches(regex, 'Location Name is not valid'),
    address: Yup.string()
      .required('Address is required'),
    pin: Yup.string()
      .required('PIN is required')
      .matches(/^\d{6}$/, 'PIN must be a 6-digit number'),
  });
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const [loader, setLoader] = useState(null);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: null,
      name: '',
      address: '',
      pin: '',
      customerType: type,
      corporateCustomerId: parseInt(customerId),
      retailCustomerId: parseInt(customerId),
      status: true,
    },
    validationSchema: LocationSchema,
    onSubmit: (values) => {
      const method = editStatus ? 'PUT' : 'POST';
      let url = 'customerLocation/create';
      if (editStatus) {
        url = '/customerLocation/update';
      }
      setLoader(true);
      request({
        url: url,
        method: method,
        data: values
      })
        .then((location) => {
          if (location.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.name);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: location['message']
                ? location['message']
                : 'Something went wrong'
            });
          }
        })
        .catch(
          function (err) {
            setLoader(false);
            console.log(err.message);
            // formik.setErrors(err)
          }.bind(this)
        );
    }
  });

  if (editStatus) {
    formik.values.id = LocationEditDatas.id;
    formik.initialValues.name = LocationEditDatas.name;
    formik.initialValues.address = LocationEditDatas.address;
    formik.initialValues.pin = LocationEditDatas.pin;
  }

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };





  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} className="ListContainer">
            <Card>
              {editStatus ? (
                <CardHeader title="Update Customer Location" />
              ) : (
                <CardHeader title="Add Customer Location" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Location Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="name"
                        value={capitalizeFirst(formik.values.name)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          // Trim leading and trailing spaces on blur
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('name', trimmedValue);
                          formik.handleBlur(e); // ensure Formik's onBlur is called
                        }}
                        error={
                          formik.touched.name &&
                          Boolean(formik.errors.name)
                        }
                        helperText={
                          formik.touched.name && formik.errors.name
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Address{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="address"
                        value={capitalizeFirst(formik.values.address)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          // Trim leading and trailing spaces on blur
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('address', trimmedValue);
                          formik.handleBlur(e); // ensure Formik's onBlur is called
                        }}
                        error={
                          formik.touched.address &&
                          Boolean(formik.errors.address)
                        }
                        helperText={
                          formik.touched.address && formik.errors.address
                        }
                      />
                    </Grid>



                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Pin Code{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="pin"
                        value={capitalizeFirst(formik.values.pin)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          // Trim leading and trailing spaces on blur
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('pin', trimmedValue);
                          formik.handleBlur(e); // ensure Formik's onBlur is called
                        }}
                        error={
                          formik.touched.pin &&
                          Boolean(formik.errors.pin)
                        }
                        helperText={
                          formik.touched.pin && formik.errors.pin
                        }
                      />
                    </Grid>



                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      <LoadingButton
                        sx={{ mt: { xs: 2, md: 0 } }}
                        loading={loader}
                        variant="contained"
                        type="submit"
                      >
                        Save
                      </LoadingButton>
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default CreatEdit;
